'use es6';

import Env from 'enviro';
import { parseUrl } from '../helpers/url';
import * as params from '../helpers/params';
import { query, header } from './core';
import { logoutOn } from './hubapi';
import { createStack } from '../index';
import { getCookie } from '../helpers/cookies';
import { logoutOnMissingPortalId } from './hubapi';
export var ensureHttps = function ensureHttps(options) {
  if (!Env.deployed('hub-http') && options.location.protocol !== 'https:') {
    var message = 'Cookie authentication require apps to be on https'; // eslint-disable-next-line no-console

    console.error('[hub-http]', message);
    throw new Error(message);
  }

  return options;
};
export var logoutOnMissingCsrf = function logoutOnMissingCsrf(options) {
  return logoutOn(function () {
    return !getCookie(options.csrfCookieName, options.cookies);
  })(options);
};
export var withCsrf = function withCsrf(options) {
  return header('X-HubSpot-CSRF-hubspotapi', getCookie(options.csrfCookieName, options.cookies))(options);
};
export var ensurePortalId = function ensurePortalId(options) {
  var parsed = parseUrl(options.url);

  if (!params.parse(parsed.query).portalId) {
    return createStack(logoutOnMissingPortalId, query({
      portalId: options.portalId
    }))(options);
  }

  return options;
};
var cookieAuthStack = createStack(logoutOnMissingCsrf, withCsrf, function (options) {
  return options.allowMissingPortalId ? options : ensurePortalId(options);
});
export var allowMissingPortalId = function allowMissingPortalId(options) {
  return Object.assign({
    allowMissingPortalId: true
  }, options);
};
export var cookieAuthentication = function cookieAuthentication(config) {
  return function (options) {
    var domainsConfig = config;
    var domain = parseUrl(options.url).hostname;
    var configForDomain = domainsConfig.find(function (dc) {
      return dc.matcher.test(domain);
    });
    return cookieAuthStack(Object.assign({}, options, {
      csrfCookieName: configForDomain.csrfCookieName
    }));
  };
};